import { Box, styled } from "@mui/material";

export const ModeSelectorBox = styled(Box, {
  name: "ModeSelectorBox",
})(`
  display: flex;
  justify-content: center;
  justify-items: center;
  align-items: center;
  align-content: center;
  margin: 0;
  padding: 12px;
`);
